var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisputeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0V24H24V0ZM3.06066 21.117C2.47487 20.5312 2.47487 19.5815 3.06066 18.9957L4.67767 17.3787H4C2.89543 17.3787 2 16.4832 2 15.3787C2 14.2741 2.89543 13.3787 4 13.3787H8.67767L10.6777 11.3787H4C2.89543 11.3787 2 10.4832 2 9.37868C2 8.27411 2.89543 7.37868 4 7.37868H14.6777L18.617 3.43934C19.2028 2.85355 20.1525 2.85355 20.7383 3.43934C21.3241 4.02513 21.3241 4.97487 20.7383 5.56066L18.9203 7.37868H20C21.1046 7.37868 22 8.27411 22 9.37868C22 10.4832 21.1046 11.3787 20 11.3787H14.9203L12.9203 13.3787H20C21.1046 13.3787 22 14.2741 22 15.3787C22 16.4832 21.1046 17.3787 20 17.3787H8.92031L5.18198 21.117C4.59619 21.7028 3.64645 21.7028 3.06066 21.117Z",
    fill: "#A40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeIcon);
export default __webpack_public_path__ + "static/media/DisputeIcon.b3ece1495fdaa0f00cdc3667c97049b1.svg";
export { ForwardRef as ReactComponent };